__webpack_require__.p = "/wp-content/themes/cricketbettingguru-theme/cgb-auth-front/dist/";